module.exports = __webpack_public_path__ + "static/media/img_gas_fee_support_l.112dba19.png";